import { LOCALE_ID, NgModule, isDevMode } from '@angular/core';

import { registerLocaleData } from '@angular/common';

import localeDe from '@angular/common/locales/de';

import { BrowserModule } from '@angular/platform-browser';

registerLocaleData(localeDe);

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { NavbarService } from './nav-menu/navmenue.service';

import { ElementReturnService } from '../Services/element-return.service';

import { MatToolbarModule } from '@angular/material/toolbar';

import { MatButtonModule } from '@angular/material/button';

import { MatInputModule } from '@angular/material/input';

import { MatFormFieldModule } from '@angular/material/form-field';

import { MatSelectModule } from '@angular/material/select';

import { MatTableModule } from '@angular/material/table';

import { MatDialogModule } from '@angular/material/dialog';

import { MatIconModule } from '@angular/material/icon';

import { MatCardModule } from '@angular/material/card';

import { MatTooltipModule } from '@angular/material/tooltip';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { MatGridListModule } from '@angular/material/grid-list';

import { MatMenuModule } from '@angular/material/menu';

import { MatProgressBarModule } from '@angular/material/progress-bar';

import { MatListModule } from '@angular/material/list';

import { MatPaginatorModule } from '@angular/material/paginator';

import { MatTabsModule } from '@angular/material/tabs';

import { MatSidenavModule } from '@angular/material/sidenav';

import { MatSortModule } from '@angular/material/sort';

import { LayoutModule } from '@angular/cdk/layout';

import { MatChipsModule } from '@angular/material/chips';

import { MatCheckboxModule } from '@angular/material/checkbox'; 

import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { MatDatepickerModule } from '@angular/material/datepicker';

import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';

import { MatButtonToggleModule } from '@angular/material/button-toggle';

import { MatExpansionModule } from '@angular/material/expansion';

import { MatSnackBarModule } from '@angular/material/snack-bar';

import { OverlayModule } from '@angular/cdk/overlay';

import { MatPaginatorIntl } from '@angular/material/paginator';

import { CustomPaginatorIntl } from './CustomClasses/custom-paginator-intl/custom-paginator-intl.service';

import { AppComponent } from './app.component';

import { NavMenuComponent } from './nav-menu/nav-menu.component';

import { HomeComponent } from './home/home.component';

import { CounterComponent } from './counter/counter.component';

import { FetchDataComponent } from './fetch-data/fetch-data.component';

import { ElementeListeComponent } from './element-liste/elemente-liste/elemente-liste.component';

import { UserListComponent } from './user-list/user-list.component';

import { UserFormComponent } from './user-form/user-form.component';

import { LoginComponent } from './user-login/user-login.component';

import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';

import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { AppRoutingModule } from './app-routing.module';

import { AuthGuard } from '../api-authorization/auth.guard';

import { AdminGuard } from '../api-authorization/AdminGuard';

import { AuthInterceptor } from '../api-authorization/auth.interceptor';

import { UserDashboardComponent } from './user-dashboard/user-dashboard.component';

import { ResetPasswordDialogComponent } from './user-form/reset-password-dialog/reset-password-dialog.component';

import { ElementDialogComponent } from './element-liste/element-dialog/element-dialog.component';

import { ChangePasswordComponent } from './change-password/change-password.component';

import { UserRegisterComponent } from './user-register/user-register.component';

import { DeviceListComponent } from './device-list/device-list.component';

import { ElementWithdrawalDialogComponent } from './elementwithdraw/element-withdrawal-dialog/element-withdrawal-dialog.component';

import { UserWithdrawalHistoryComponent } from './elementwithdraw/user-withdrawal-history/user-withdrawal-history.component';

import { ElementWithdrawalHistoryComponent } from './elementwithdraw/element-withdrawal-history/element-withdrawal-history.component';

import { ConfirmDialogComponent } from './shared/confirm-dialog/confirm-dialog.component';

import { ConfirmDeleteDialogComponent } from './user-list/confirm-delete-dialog/confirm-delete-dialog.component';

import { WartungDashboardComponent } from './Wartung/wartung-dashboard/wartung-dashboard.component';

import { CustomerListComponent } from './Wartung/customer-list/customer-list.component';

import { CustomerDetailComponent } from './Wartung/customer-detail/customer-detail.component';

import { CustomerFormComponent } from './Wartung/customer-form/customer-form.component';

import { EquipmentFormComponent } from './Wartung/equipment-form/equipment-form.component';

import { MaintenanceFormComponent } from './Wartung/maintenance-form/maintenance-form.component';

import { MaintenanceDetailComponent } from './Wartung/maintenance-detail/maintenance-detail.component';

import { ServiceReportDialogComponent } from './Wartung/shared/service-report-dialog/service-report-dialog.component';

import { ServiceCallFormComponent } from './Wartung/service-call-form/service-call-form.component';

import { CommercialBillingComponent } from './Wartung/commercial-billing/commercial-billing.component';

import { SbomListComponent } from './Sbom/sbom-list/sbom-list.component';

import { SbomDetailComponent } from './Sbom/sbom-detail/sbom-detail.component';

import { SbomProjectFormComponent } from './Sbom/sbom-project-form/sbom-project-form.component';

import { SbomComponentFormComponent } from './Sbom/sbom-component-form/sbom-component-form.component';

import { SecurityAssessmentComponent } from './Sbom/security-assessment/security-assessment.component';

import { BerichteComponent } from './berichte/berichte.component';

import { InbetriebnahmeComponent } from './Wartung/inbetriebnahme/inbetriebnahme.component';

import { MessstellenImportComponent } from './Wartung/inbetriebnahme/messstellen-import/messstellen-import.component';

import { MessstellenListeComponent } from './Wartung/inbetriebnahme/messstellen-liste/messstellen-liste.component';

import { MessstelleDetailComponent } from './Wartung/inbetriebnahme/messstelle-detail/messstelle-detail.component';

import { GeraeteArtefakteComponent } from './Wartung/inbetriebnahme/messstelle-detail/geraete-artefakte/geraete-artefakte.component';

import { ProjekteComponent } from './Projekte/projekte.component';

import { ProjektDetailComponent } from './Projekte/projekt-detail/projekt-detail.component';

import { IbnProtokollDialogComponent } from './Projekte/projekt-detail/ibn-protokoll-dialog/ibn-protokoll-dialog.component';

import { IbnProtokollMessstelleDialogComponent } from './Projekte/projekt-detail/ibn-protokoll-dialog/messstelle/ibn-protokoll-messstelle-dialog.component';

import { IbnProtokollMessstellenDialogComponent } from './Projekte/projekt-detail/ibn-protokoll-dialog/messstellen/ibn-protokoll-messstellen-dialog.component';

import { KategorieAdminComponent } from './Admin/kategorie-admin/kategorie-admin.component';

import { StammkundenListComponent } from './Stammkunden/stammkunden-list/stammkunden-list.component';

import { StammkundeDetailComponent } from './Stammkunden/stammkunde-detail/stammkunde-detail.component';

import { AuftragFormComponent } from './Stammkunden/auftrag-form/auftrag-form.component';

import { AuftragDetailComponent } from './Stammkunden/auftrag-detail/auftrag-detail.component';

import { EinsatzFormComponent } from './Stammkunden/einsatz-form/einsatz-form.component';

import { EinsatzPlanungComponent } from './Stammkunden/einsatz-planung/einsatz-planung.component';

import { TeamFormComponent } from './Stammkunden/team-form/team-form.component';

import { WorkerFormComponent } from './Stammkunden/worker-form/worker-form.component';

import { LagerLinkComponent } from './Stammkunden/lager-link/lager-link.component';

import { MeineEinsaetzeComponent } from './Stammkunden/meine-einsaetze/meine-einsaetze.component';

import { BauleiterUebersichtComponent } from './Stammkunden/bauleiter-uebersicht/bauleiter-uebersicht.component';

import { ZeitEintragFormComponent } from './Stammkunden/zeit-eintrag-form/zeit-eintrag-form.component';

import { StundenErfassungComponent } from './Stammkunden/stunden-erfassung/stunden-erfassung.component';

import { MaterialErfassungComponent } from './Stammkunden/material-erfassung/material-erfassung.component';

import { SpontanEinsatzFormComponent } from './Stammkunden/spontan-einsatz-form/spontan-einsatz-form.component';

import { TakedaTagesberichtComponent } from './Stammkunden/takeda-tagesbericht/takeda-tagesbericht.component';
import { TakedaExcelExportDialogComponent } from './Stammkunden/shared/takeda-excel-export-dialog/takeda-excel-export-dialog.component';

import { OfflineStatusComponent } from './shared/offline-status/offline-status.component';

import { OfflineProjektComponent } from './shared/offline-projekt/offline-projekt.component';

import { SyncKonfliktDialogComponent } from './shared/sync-konflikt-dialog/sync-konflikt-dialog.component';

import { IbnWizardOverlayComponent } from './shared/ibn-wizard/ibn-wizard-overlay.component';

import { KategorieAuswahlComponent } from './shared/kategorie-auswahl/kategorie-auswahl.component';

import { KategorieVorschauComponent } from './shared/kategorie-auswahl/kategorie-vorschau.component';

import { ServiceWorkerModule } from '@angular/service-worker';

import { MessstellePublicComponent }

  from './Wartung/inbetriebnahme/messstelle-public/messstelle-public.component';

import { MessstelleQrDialogComponent }

  from './Wartung/inbetriebnahme/messstelle-qr-dialog/messstelle-qr-dialog.component';

import { QrCodeAdminComponent } from './Admin/qr-code-admin/qr-code-admin.component';

import { MessstelleQrScannerDialogComponent } from './Wartung/inbetriebnahme/messstelle-detail/messstelle-qr-scanner-dialog/messstelle-qr-scanner-dialog.component';

import { MessstelleDuplizierenDialogComponent } from './Wartung/inbetriebnahme/messstellen-liste/messstelle-duplizieren-dialog/messstelle-duplizieren-dialog.component';

import { ListentypAuswahlDialogComponent } from './Wartung/inbetriebnahme/sps/listentyp-auswahl-dialog/listentyp-auswahl-dialog.component';

// Manuell erstellte Inbetriebnahmelisten: Struktur-Editor, Vorlagen, Erstellen
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatRadioModule } from '@angular/material/radio';
import { StrukturEditorComponent } from './Wartung/inbetriebnahme/listen-struktur/struktur-editor/struktur-editor.component';
import { StrukturVorschauComponent } from './Wartung/inbetriebnahme/listen-struktur/struktur-vorschau/struktur-vorschau.component';
import { ListeErstellenComponent } from './Wartung/inbetriebnahme/listen-struktur/liste-erstellen/liste-erstellen.component';
import { StrukturVorlagenComponent } from './Wartung/inbetriebnahme/listen-struktur/struktur-vorlagen/struktur-vorlagen.component';
import { StrukturBearbeitenDialogComponent } from './Wartung/inbetriebnahme/listen-struktur/struktur-bearbeiten-dialog/struktur-bearbeiten-dialog.component';
import { AlsVorlageDialogComponent } from './Wartung/inbetriebnahme/listen-struktur/als-vorlage-dialog/als-vorlage-dialog.component';

import { SpsBreadcrumbsComponent } from './Wartung/inbetriebnahme/sps/sps-breadcrumbs/sps-breadcrumbs.component';

import { SpsMehrfachImportComponent } from './Wartung/inbetriebnahme/sps/sps-mehrfach-import/sps-mehrfach-import.component';

import { SpsListeComponent } from './Wartung/inbetriebnahme/sps/sps-liste/sps-liste.component';

import { SpsPruefungComponent } from './Wartung/inbetriebnahme/sps/sps-pruefung/sps-pruefung.component';

import { SpsSignalDetailComponent } from './Wartung/inbetriebnahme/sps/sps-signal-detail/sps-signal-detail.component';

import { SpsZuordnungComponent } from './Wartung/inbetriebnahme/sps/sps-zuordnung/sps-zuordnung.component';

import { SpsListenUebersichtComponent } from './Wartung/inbetriebnahme/sps/sps-listen-uebersicht/sps-listen-uebersicht.component';

import { SpsBemerkungDialogComponent } from './Wartung/inbetriebnahme/sps/sps-bemerkung-dialog/sps-bemerkung-dialog.component';

import { SpsSignalLoeschenDialogComponent } from './Wartung/inbetriebnahme/sps/sps-signal-loeschen-dialog/sps-signal-loeschen-dialog.component';

import { SpsListenUpdateDialogComponent } from './Wartung/inbetriebnahme/sps/sps-listen-update-dialog/sps-listen-update-dialog.component';

import { ResourceTeamManagementComponent } from './Ressourcenplanung/team-verwaltung/resource-team-management.component';

import { ResourceAdministrationComponent } from './Ressourcenplanung/administration/resource-administration.component';

import { ResourceTeamDetailComponent } from './Ressourcenplanung/team-verwaltung/team-detail/resource-team-detail.component';

import { ResourceEmployeeDirectoryComponent } from './Ressourcenplanung/team-verwaltung/employee-directory/resource-employee-directory.component';

import { ResourceEmployeeProfileComponent } from './Ressourcenplanung/team-verwaltung/employee-profile/resource-employee-profile.component';

import { ResourceTeamFormDialogComponent } from './Ressourcenplanung/team-verwaltung/team-form-dialog/resource-team-form-dialog.component';

import { ResourcePlanningMembersDialogComponent } from './Ressourcenplanung/team-verwaltung/planning-members-dialog/resource-planning-members-dialog.component';

import { ResourcePlanningComponent } from './Ressourcenplanung/planning/resource-planning.component';

import { ResourceAssignmentEditorComponent }

  from './Ressourcenplanung/assignment-editor/resource-assignment-editor.component';

import { ResourceMyCalendarComponent } from './Ressourcenplanung/my-calender/resource-my-calendar.component';

import { ResourceAssignmentTooltipComponent } from './Ressourcenplanung/shared/assignment-tooltip/resource-assignment-tooltip.component';

import { ResourceMyCalendarWeekComponent } from './Ressourcenplanung/my-calender/week-view/resource-my-calendar-week.component';

import { ResourceMyCalendarMonthComponent } from './Ressourcenplanung/my-calender/month-view/resource-my-calendar-month.component';

import { ResourceShellComponent } from './Ressourcenplanung/shell/resource-shell.component';

import { ResourceCapacityComponent } from './Ressourcenplanung/capacity/resource-capacity.component';

import { ResourceAbsencesComponent } from './Ressourcenplanung/absences/resource-absences.component';

import { ResourceVerwaltungComponent } from './Ressourcenplanung/verwaltung/resource-verwaltung.component';

import { ResourceMonitorComponent } from './Ressourcenplanung/monitor/resource-monitor.component';

import { ResourceCatalogComponent } from './Ressourcenplanung/verwaltung/catalog/resource-catalog.component';

import { ResourceHiddenExternalEventsDialogComponent }

  from './Ressourcenplanung/planning/hidden-external-events-dialog/resource-hidden-external-events-dialog.component';

@NgModule({

  declarations: [

    AppComponent,

    NavMenuComponent,

    HomeComponent,

    CounterComponent,

    FetchDataComponent,

    ElementeListeComponent,

    UserListComponent,

    UserFormComponent,

    LoginComponent,

    ForgotPasswordComponent,

    UserDashboardComponent,

    ResetPasswordDialogComponent,

    ElementDialogComponent,

    ChangePasswordComponent,

    UserRegisterComponent,

    DeviceListComponent,

    ElementWithdrawalDialogComponent,

    UserWithdrawalHistoryComponent,

    ElementWithdrawalHistoryComponent,

    ConfirmDialogComponent,

    ConfirmDeleteDialogComponent,

    WartungDashboardComponent,

    CustomerListComponent,

    CustomerDetailComponent,

    CustomerFormComponent,

    EquipmentFormComponent,

    MaintenanceFormComponent,

    MaintenanceDetailComponent,

    ServiceReportDialogComponent,

    ServiceCallFormComponent,

    CommercialBillingComponent,


    SbomListComponent,

    SbomDetailComponent,

    SbomProjectFormComponent,

    SbomComponentFormComponent,

    SecurityAssessmentComponent,

    BerichteComponent,

    InbetriebnahmeComponent,

    MessstellenImportComponent,

    MessstellenListeComponent,

    MessstelleDetailComponent,

    GeraeteArtefakteComponent,

    ProjekteComponent,

    ProjektDetailComponent,

    IbnProtokollDialogComponent,

    IbnProtokollMessstelleDialogComponent,

    IbnProtokollMessstellenDialogComponent,

    MessstellePublicComponent,

    MessstelleQrDialogComponent,

    KategorieAdminComponent,



    ResourceTeamManagementComponent,

    ResourceAdministrationComponent,

    ResourceTeamDetailComponent,

    ResourceEmployeeDirectoryComponent,

    ResourceEmployeeProfileComponent,

    ResourceTeamFormDialogComponent,

    ResourcePlanningMembersDialogComponent,

    ResourcePlanningComponent,

    ResourceAssignmentEditorComponent,

    ResourceShellComponent,

    ResourceMyCalendarComponent,

    ResourceAssignmentTooltipComponent,

    ResourceMyCalendarWeekComponent,

    ResourceMyCalendarMonthComponent,

    ResourceCapacityComponent,

    ResourceAbsencesComponent,

    ResourceVerwaltungComponent,

    ResourceMonitorComponent,

    ResourceCatalogComponent,

    ResourceHiddenExternalEventsDialogComponent,



    StammkundenListComponent,

    StammkundeDetailComponent,

    AuftragFormComponent,

    AuftragDetailComponent,

    EinsatzFormComponent,

    EinsatzPlanungComponent,

    TeamFormComponent,

    WorkerFormComponent,

    LagerLinkComponent,

    MeineEinsaetzeComponent,

    BauleiterUebersichtComponent,

    ZeitEintragFormComponent,

    StundenErfassungComponent,

    MaterialErfassungComponent,

    SpontanEinsatzFormComponent,

    TakedaTagesberichtComponent,
    TakedaExcelExportDialogComponent,

    OfflineStatusComponent,

    OfflineProjektComponent,

    SyncKonfliktDialogComponent,

    IbnWizardOverlayComponent,

    KategorieAuswahlComponent,

    KategorieVorschauComponent,

    QrCodeAdminComponent,

    MessstelleQrScannerDialogComponent,

    MessstelleDuplizierenDialogComponent,

    ListentypAuswahlDialogComponent,



    SpsBreadcrumbsComponent,

    StrukturEditorComponent,
    StrukturVorschauComponent,
    ListeErstellenComponent,
    StrukturVorlagenComponent,
    StrukturBearbeitenDialogComponent,
    AlsVorlageDialogComponent,

    SpsMehrfachImportComponent,

    SpsListeComponent,

    SpsPruefungComponent,

    SpsSignalDetailComponent,

    SpsZuordnungComponent,

    SpsListenUebersichtComponent,

    SpsBemerkungDialogComponent,
    SpsSignalLoeschenDialogComponent,
    SpsListenUpdateDialogComponent,

  ],

  imports: [

    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),

    HttpClientModule,

    FormsModule,

    ReactiveFormsModule,

    BrowserAnimationsModule,

    LayoutModule,

    OverlayModule,

    MatCheckboxModule,

    MatSlideToggleModule,

    MatToolbarModule,

    MatButtonModule,

    MatInputModule,

    MatFormFieldModule,

    MatSelectModule,

    MatTableModule,

    MatDialogModule,

    MatIconModule,

    MatCardModule,

    MatTooltipModule,

    MatProgressSpinnerModule,

    MatGridListModule,

    MatMenuModule,

    MatProgressBarModule,

    MatListModule,

    MatPaginatorModule,

    MatTabsModule,

    MatSidenavModule,

    AppRoutingModule,

    MatAutocompleteModule,

    MatSortModule,

    MatChipsModule,

    MatDatepickerModule,

    MatNativeDateModule,

    MatButtonToggleModule,
    MatRadioModule,
    DragDropModule,

    MatExpansionModule,

    MatSnackBarModule,

    ServiceWorkerModule.register('ngsw-worker.js', {

      enabled: !isDevMode(),



      registrationStrategy: 'registerWhenStable:30000'

    }),

  ],

  providers: [

    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },

    { provide: MatPaginatorIntl, useClass: CustomPaginatorIntl },

    { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },

    { provide: LOCALE_ID, useValue: 'de' },

    AuthGuard,

    AdminGuard,

    NavbarService,

    ElementReturnService

  ],

  bootstrap: [AppComponent]

})

export class AppModule { }
